import * as React from "react";
import { SVGProps } from "react";
const SvgAskEon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.148 18.755a1 1 0 0 1 .761.352L21 26.282V23a1 1 0 0 1 1-1h3a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7.732l-1.345-1.597a1 1 0 0 1 .76-1.648h.001Zm8.198 11.184a1 1 0 0 1-1.107-.291L16.432 24H7a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4h-2v5c0 .419-.262.794-.654.939ZM21 13a1.501 1.501 0 0 1 1.087 2.573A1.5 1.5 0 1 1 21 13Zm-5 0a1.501 1.501 0 0 1 1.087 2.573A1.5 1.5 0 1 1 16 13Zm-3.5 1.5a1.501 1.501 0 0 1-2.573 1.086A1.5 1.5 0 1 1 12.5 14.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAskEon;
